import { useNavigate } from '@tanstack/react-router'
import { ErrorState, Skeleton } from '@shared/design-system/ui'
import { useMemberCatalogOfferQuery } from '../api/member-access.queries'
import { useMemberSession } from '../model/member-session-store'
import { MemberAccessLayout } from './MemberAccessLayout'
import { MemberCourseOffer } from './MemberCourseOffer'

export function MemberLockedCoursePage({ producerId, productId }: { producerId: string; productId: string }) {
  const navigate = useNavigate()
  const token = useMemberSession((state) => state.token)
  const memberEmail = useMemberSession((state) => state.member?.email)
  const offer = useMemberCatalogOfferQuery(productId, Boolean(token))

  if (!token) {
    void navigate({ to: '/acesso/$producerId', params: { producerId } })
    return null
  }
  if (offer.data?.owned) {
    void navigate({
      to: '/acesso/$producerId/cursos/$productId',
      params: { producerId, productId },
    })
    return null
  }
  if (offer.isPending) {
    return (
      <MemberAccessLayout producerName="Área de membros" catalogBackProducerId={producerId}>
        <Skeleton height={280} radius="16px" />
      </MemberAccessLayout>
    )
  }
  if (offer.isError || !offer.data) {
    return (
      <MemberAccessLayout producerName="Área de membros" catalogBackProducerId={producerId}>
        <ErrorState
          title="Não foi possível abrir este curso"
          description="Tente de novo a partir do catálogo."
          onRetry={() => void offer.refetch()}
        />
      </MemberAccessLayout>
    )
  }

  return (
    <MemberAccessLayout producerName="Área de membros" catalogBackProducerId={producerId}>
      <MemberCourseOffer offer={offer.data} memberEmail={memberEmail} />
    </MemberAccessLayout>
  )
}
